import * as Cookies from 'js-cookie';
//js-cookie is also added by woocommerce!

export default {
  init() {
    // JavaScript to be fired on all pages        
    
    $(document).ready(function() {
      
      $('a.wc-block-grid__product-link').attr('target', '_blank');

      // Show the modal, with delay func.
      $('#myModal').appendTo('body');
      function show_modal(){
        $('#myModal').modal();
        //$(window).trigger('resize');
      }

      // If no cookie with our chosen name (e.g. no_thanks)...
      if (Cookies.get('no_thanks') == null) {
        // Set delay func. time in milliseconds
        window.setTimeout(show_modal, 15000);
        Cookies.set('no_thanks', 'true', { expires: 30, path: '/' });
      }

      // On click of specified class (e.g. 'nothanks'), trigger cookie, which expires in 30 days
/*
      $('.nothanks').click(function() {
        Cookies.set('no_thanks', 'true', { expires: 30, path: '/' });
      });
*/
      
    });

    var $hamburger = $('.hamburger');
    $hamburger.on('click', function() {
      $hamburger.toggleClass('is-active');
    });
    
    var limit = 0.3, //implies 60 vh or 60% of viewport height
    scrollLimit = 0;
    $(window).resize(function(){
      scrollLimit = $(window).height() * limit;
    }).scroll(function() {    
      var scroll = $(window).scrollTop(); 
      if (scroll >= scrollLimit ) {
        $('header.banner').addClass('scrolled');
        } else {
        $('header.banner').removeClass('scrolled');
      }
    }).trigger('resize').trigger('scroll'); // trigger both events on start to force initial setup
            
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js